module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_vm._l((_vm.row.subject_list), function(subject, index) {
    return _c('div', [_c('van-divider', [_vm._v("项目信息" + _vm._s(index + 1) + "\n            ")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "is-link": "",
        "input-align": "right",
        "title": "项目",
        "value": "请选择项目"
      },
      on: {
        "click": function($event) {
          return _vm.openSubjectPicker(_vm.subjectOptionsAll, index)
        }
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.subject_name),
        expression: "subject.subject_name"
      }],
      staticClass: "operate-desc-left"
    }, [_vm._v(_vm._s(subject.subject_name))]), _vm._v(" "), (subject.music_url) ? _c('van-cell', {
      attrs: {
        "title": "音乐",
        "value": "点击试听",
        "is-link": ""
      },
      on: {
        "click": function($event) {
          _vm.playMusicUrl = subject.music_url
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('van-action-sheet', {
      attrs: {
        "actions": _vm.subjectOptions
      },
      on: {
        "click-overlay": _vm.onSubjectClose,
        "select": _vm.onSubjectSelect
      },
      model: {
        value: (_vm.showSubjectPicker),
        callback: function($$v) {
          _vm.showSubjectPicker = $$v
        },
        expression: "showSubjectPicker"
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "right-icon": "arrow",
        "input-align": "right",
        "label": "参赛运动员",
        "placeholder": "请选择运动员"
      },
      on: {
        "click": function($event) {
          subject.showYundongyuanPicker = true;
          _vm.thisSubjectIndex = index
        }
      }
    }), _vm._v(" "), _c('YundongyuanPicker', {
      attrs: {
        "show": subject.showYundongyuanPicker,
        "limit": 30,
        "defaultValue": subject.yundongyuan
      },
      on: {
        "onChange": _vm.onYundongyuanChange,
        "onClose": function($event) {
          subject.showYundongyuanPicker = false
        },
        "onConfirm": _vm.onYundongyuanConfirm
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.yundongyuan.length > 0),
        expression: "subject.yundongyuan.length>0"
      }],
      staticClass: "memberResultWrap"
    }, _vm._l((subject.yundongyuan), function(yundongyuan, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n                        运动员" + _vm._s(index + 1) + "\n                        "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "closeable": "",
          "type": "primary"
        },
        on: {
          "close": function($event) {
            return subject.yundongyuan.splice(index, 1)
          }
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(yundongyuan.num) + "\n                        ")])], 1)
    }), 0), _vm._v(" "), (false) ? _c('van-field', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "right-icon": "arrow",
        "input-align": "right",
        "label": "替补运动员",
        "placeholder": "请选择运动员"
      },
      on: {
        "click": function($event) {
          subject.showTbYundongyuanPicker = true;
          _vm.thisSubjectIndex = index
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.tbydy.length > 0),
        expression: "subject.tbydy.length>0"
      }],
      staticClass: "memberResultWrap"
    }, _vm._l((subject.tbydy), function(tbydy, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n                        替补运动员" + _vm._s(index + 1) + "\n                        "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "closeable": "",
          "type": "primary"
        },
        on: {
          "close": function($event) {
            return subject.tbydy.splice(index, 1)
          }
        }
      }, [_vm._v(" " + _vm._s(tbydy.name) + " " + _vm._s(tbydy.num) + "\n                        ")])], 1)
    }), 0), _vm._v(" "), (_vm.row.subject_list.length > 0) ? _c('YundongyuanPicker', {
      attrs: {
        "show": subject.showTbYundongyuanPicker,
        "limit": 30,
        "defaultValue": subject.tbydy
      },
      on: {
        "onChange": _vm.onTbYundongyuanChange,
        "onClose": function($event) {
          subject.showTbYundongyuanPicker = false
        },
        "onConfirm": _vm.onTbYundongyuanConfirm
      }
    }) : _vm._e(), _vm._v(" "), (false) ? _c('van-cell', {
      attrs: {
        "title": "自选音乐",
        "value": subject.music.length + '/1'
      }
    }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
      staticClass: "row"
    }, [_c('FileUploader', {
      attrs: {
        "fileList": subject.music,
        "limit": 1,
        "accept": ".mp3",
        "name": 'music'
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('van-field', {
      attrs: {
        "readonly": "",
        "clickable": "",
        "right-icon": "arrow",
        "input-align": "right",
        "label": "教练员",
        "placeholder": "请选择教练员"
      },
      on: {
        "click": function($event) {
          subject.showJiaolianPicker = true;
          _vm.thisSubjectIndex = index
        }
      }
    }), _vm._v(" "), _c('SubjectJiaolianPicker', {
      attrs: {
        "show": subject.showJiaolianPicker,
        "limit": 5,
        "options": _vm.row.jiaolian_options,
        "defaultValue": subject.jiaolian
      },
      on: {
        "onChange": _vm.onJiaolianChange,
        "onClose": function($event) {
          subject.showJiaolianPicker = false
        },
        "onConfirm": _vm.onJiaolianConfirm
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.jiaolian.length > 0),
        expression: "subject.jiaolian.length>0"
      }],
      staticClass: "memberResultWrap"
    }, [_vm._l((subject.jiaolian), function(jiaolian, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n                        教练员" + _vm._s(index + 1) + "\n                        "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "closeable": "",
          "type": "primary"
        },
        on: {
          "close": function($event) {
            return subject.jiaolian.splice(index, 1)
          }
        }
      }, [_vm._v(" " + _vm._s(jiaolian.name) + " " + _vm._s(jiaolian.num) + "\n                        ")])], 1)
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "28px",
        "padding-top": "10px",
        "font-size": "14px",
        "text-align": "center",
        "color": "#666"
      }
    }, [_vm._v("此处教练员顺序即为获奖证书的教练员顺序"), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("请谨慎选择")])])], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "0.2rem"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('van-button', {
      staticStyle: {
        "width": "3rem"
      },
      attrs: {
        "native-type": "button",
        "size": "normal",
        "round": "",
        "icon": "close"
      },
      on: {
        "click": function($event) {
          return _vm.subjectRemove(subject, index)
        }
      }
    }, [_vm._v("删除项目")])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin-top": "0.4rem"
    },
    attrs: {
      "native-type": "button",
      "size": "normal",
      "round": "",
      "icon": "plus"
    },
    on: {
      "click": _vm.subjectAdd
    }
  }, [_vm._v("新增项目")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 2), _vm._v(" "), (_vm.showWxShare) ? _c('div', {
    staticClass: "shareShow",
    on: {
      "click": function($event) {
        _vm.showWxShare = false
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '30%'
    }),
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.show_share_panel),
      callback: function($$v) {
        _vm.show_share_panel = $$v
      },
      expression: "show_share_panel"
    }
  }, [_c('div', {
    staticClass: "share-panel"
  }, [_c('div', {
    staticClass: "share-title"
  }, [_vm._v("请选择分享方式")]), _vm._v(" "), _c('div', {
    staticClass: "share-ul"
  }, [_c('div', {
    staticClass: "share-weixin",
    on: {
      "click": _vm.shareWeixinFriend
    }
  }, [_c('p', [_vm._v("微信好友")])]), _vm._v(" "), _c('div', {
    staticClass: "share-timeline",
    on: {
      "click": _vm.shareWeixinTimeLine
    }
  }, [_c('p', [_vm._v("朋友圈")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.copy_text),
      expression: "copy_text",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (function() {
        _vm.copySuccess();
        _vm.show_share_panel = false
      }),
      expression: "function(){copySuccess();show_share_panel=false }",
      arg: "success"
    }],
    staticClass: "share-copy"
  }, [_c('p', [_vm._v("复制链接")])])])])]), _vm._v(" "), (_vm.playMusicUrl) ? _c('audio', {
    staticStyle: {
      "position": "fixed",
      "bottom": "20px",
      "left": "0",
      "right": "0",
      "z-index": "9999999"
    },
    attrs: {
      "autoplay": "",
      "src": _vm.playMusicUrl,
      "controls": "controls"
    }
  }) : _vm._e(), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点击分享给好友(朋友圈)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1169fb51","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormFamliyStep2.vue
// module id = 1321
// module chunks = 0